import React, { useEffect } from "react";
import {FormularioIngreso} from './FormularioIngreso'
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {Grid, Typography} from '@material-ui/core';
import { SelectTipoCategoria } from "./SelectCategoria";
import { configuracionCategoriaLimpiar, traerConfiguracionPorCategoria } from "../../../actions/configuraciones/ConfiguracionCategoria";


const useStyles = makeStyles({
  rootTitulo:{
      color:'white',
      marginBottom:20
  }
});


export const HomeCategoriaRelacion = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {items} = useSelector(state => state.configuracionesCategoria)  
  const handleChange = (event) => {
    dispatch(traerConfiguracionPorCategoria(event.target.value));
  };

  useEffect(() => {
    dispatch( configuracionCategoriaLimpiar() );
  }, [dispatch]);
  
  return (
    <Grid lg={12}>  
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid >
            <SelectTipoCategoria apiUrl={'situacionrevista'}  handleChange={handleChange}/>
          </Grid>
          <Typography component="h3" variant="h5" className={classes.rootTitulo}>Categorias por Afiliacion</Typography>
          <Grid>
            <FormularioIngreso items={items}/>
          </Grid>
        </Grid>
    </Grid>
  );

};
